import { gsap } from "gsap";

export default class HomepageSlides {
    constructor() {
        const slides = document.querySelectorAll('.homepage-slide__wrapper');
        const slideConfigs = [
            {
                featureImage: { x: 100, y: -815 },
                backgroundImage: { x: 1750, y: 0 }
            },
            {
                featureImage: { x: -50, y: -750 },
                backgroundImage: { x: 800, y: 50 }
            },
            {
                featureImage: { x: 150, y: -775 },
                backgroundImage: { x: 700, y: -50 }
            },
            {
                featureImage: { x: 0, y: -750 },
                backgroundImage: { x: 1225, y: 0 }
            }
        ];

        const headerTimeline = gsap.timeline({
            delay: 0,
            repeat: -1,
        });
        
        slides.forEach((slide, index) => {
            const elements = {
                heading: document.querySelectorAll('.homepage-slide__content-title h1')[index],
                featureImage: document.querySelectorAll('.homepage-slide__images-feature')[index],
                backgroundImage: document.querySelectorAll('.homepage-slide__images-background')[index],
                chevron: document.querySelectorAll('.icon-chevron')[index],
                details: document.querySelectorAll('.homepage-slide__content-details')[index],
                offer: document.querySelectorAll('.homepage-slide__content-offer')[index]
            };

            const config = slideConfigs[index] || {
                featureImage: { x: 0, y: 0 },
                backgroundImage: { x: 0, y: 0 }
            };

            const duration = 0.3;

            headerTimeline.add(() => {
                slides.forEach((s, i) => {
                    s.classList.toggle('active', i === index);
                });
            });

            headerTimeline
                .fromTo(elements.heading, { y: -175 }, { y: 0, duration: duration }, "<")
                .fromTo(elements.chevron, { opacity: 0 }, { opacity: 1, duration: 0.05 }, "<")
                .fromTo([elements.details, elements.offer], { opacity: 0 }, { opacity: 1, duration: duration }, "<")
                .fromTo(
                    elements.featureImage,
                    { x: config.featureImage.x, y: config.featureImage.y },
                    { x: 0, y: 0, duration: duration, ease: "power3.out" }
                )
                .fromTo(
                    elements.backgroundImage,
                    { x: config.backgroundImage.x, y: config.backgroundImage.y },
                    { x: 0, y: 0, duration: duration, ease: "power3.out" }
                )
                .to(elements.chevron, { opacity: 0, duration: 0.05, delay: 10 })
                .to(elements.heading, { y: 175, duration: duration }, "<")
                .to([elements.details, elements.offer], { opacity: 0, duration: duration }, "<")
                .to(
                    elements.featureImage,
                    { x: config.featureImage.x, y: config.featureImage.y, duration: duration }
                )
                .to(
                    elements.backgroundImage,
                    { x: config.backgroundImage.x, y: config.backgroundImage.y, duration: duration }
                );
        });
    }
}
